/**
 * Escapes every character that has a special meaning in JS regular expressions
 * plus a few extra trouble-makers (`-`, `/`).
 * Useful to build a regex from a string.
 * @param input the string to escape
 * @returns the string with special characters escaped
 */
export function escapeRegexCharacters(input: string): string {
  return input.replace(REGEX_SPECIAL_CHARS, '\\$&')
}

/**
 * Builds a regex matching standalone occurrences of `term`, so it isn't matched when buried inside
 * a longer, unrelated word.
 */
export function buildStandaloneTermRegex(term: string): RegExp {
  return new RegExp(`\\b${escapeRegexCharacters(term)}\\b`)
}

const REGEX_SPECIAL_CHARS = /[.*+?^${}()|[\]\\/-]/g
